const PendoIcon = ({ size = 24 }: { size?: number | string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    height={size}
    fill="none"
  >
    <path fill="url(#pendo-a)" d="M4 4h16v16H4z" />
    <defs>
      <pattern id="pendo-a" width={1} height={1} patternContentUnits="objectBoundingBox">
        <use xlinkHref="#pendo-b" transform="scale(.00357)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAAEYCAYAAACHjumMAAAIUklEQVR4nOzdvY5cSRnH4V5kAgggINmQ0EtE6FsgBSGZgJyMzSGEvG8CsQGevQQ22MBXsIQQEgJCHku7Uq/s9dgzZ6q7z0ed+znheUIHVkd/Vf1UR/PkdDodAPbwvdo/AIjrSe0fQD9eHV88vT3ePK/9O2jeFz/511++OBgY5vr65Vcf3x5vPj8cDk9r/xa68HZgXJG46tXxxc//9/zPfzcuLOUEw0X/ff6n33/z8h/H2r+DPjnBcJZxYSsDQ9Kba5FxYSsDwyNvxuX2ePPX2r+D/mkwPOBaRE5OMLxnXMjNwPCW5sIeDAx3j+g0F7IzMIPziI49ibwD01zYmxPMoIwLJRiYAQm6lGJgBiPoUpKBGYigS2ki7yA0F2pwghmAcaEWAxOcoEtNBiYwX0VTmwYTlGsRLXCCCci40AoDE4zmQksMTCAe0dEaAxOER3S0SOQNQHOhVU4wnTMutMzAdEzQpXUGplOCLj0wMB0SdOmFyNsZzYWeOMF0xLjQGwPTCUGXHhmYDgi69EqDady7a9HvBF16ZGAaprnQO1ekRmkuRGBgGqS5EIWBaYxHdESiwTREcyEaJ5hGGBciMjANEHSJysBUJugSmYGpSNAlOpG3Es2FETjBVGBcGIWBKUzQZSQGpiBBl9FoMIX4KpoRGZgCNBdG5Yq0M82FkRmYHWkujM7A7MQjOtBgdqG5wHecYDIzLvCBgclI0IWHDEwmgi48ZmAyEHQhTeTdSHOB85xgNjAucJmBWUnQhesMzAqCLsyjwSzkq2iYz8AsoLnAMq5IM2kusJyBmUFzgXUMzBUe0cF6GswFmgts4wRzhnGB7QxMgqALeRiYCUEX8jEw9wi6kJfI+47mAvk5wRgX2M3wA/P1y68+fvdtEZDZ0AOjucC+hm0wrkWwvyFPMMYFyhhuYDyig3KGGhiP6KCsYQZG0IXyhoi8mgvUEf4EY1ygntADI+hCXWEHRtCF+kIOjKALbQgXeTUXaEeoE4xxgbaEGRhfRUN7QgyM5gJt6r7BuBZBu7o+wRgXaFu3A+MRHbSvy4HxiA76EOLqIQVTYNiYAAAAAElFTkSuQmCC"
        id="pendo-b"
        width={280}
        height={280}
      />
    </defs>
  </svg>
);

export default PendoIcon;
